import React, { useMemo } from 'react';

import CustomDropdown from '@components/CustomDropdown';

import CollectionInfo from '@features/design/components/CollectionInfo';
import DesignEditInput from '@features/design/components/DesignEditInput';
import DesignImageUpdate from '@features/design/components/DesignImageUpdate';
import DesignTag from '@features/design/components/DesignTags';
import DropdownWrapper from '@features/design/components/DropdownWrapper';
// import FittingInfo from '@features/design/components/FittingInfo';
import { NITEX_DESIGN } from '@features/design/utils/designUtils';

import { capitalizeFirstLetter, convertDateToLocal, isAdmin } from '@utils/Util';

// import { ReactComponent as InfoIcon } from '@/assets/icons/exclamation-mark.svg';
// import CommonImage from '@/components/CommonImage';

const DesignBasicInfoSection = ({
	productId,
	isDesignEdit,
	onDesignUpload,
	onCropeImage,
	selectedImage,
	categories,
	fabricType,
	// bodyFabric,
	designers,
	tpCompleatedBy,
	looks,
	tags,
	onDesignInputChange,
	onSelectOption,
	// onGetBodyFabrics,
	onUpdateTagList,
	onGetAllTags,
	// onUpdateBodyFabric,
	selectedDesignInfo,
	marketList,
	brands,
	designDetails,
	// onParseInputName,
	remarks,
	setRemarks,
	errors = {},
	graphicDesigners,
	threeDDesigner
}) => {
	const isEditable = () => {
		if (!isDesignEdit) return false;
		return designDetails?.availabilityStatus === 'SOLD' || designDetails?.isBuyerSelected
			? isAdmin()
			: true;
	};

	const isOption = () => {
		return designDetails?.isOption ? isAdmin() : true;
	};

	// Sort graphic designers to put logged-in user at the top
	const sortedGraphicDesigners = useMemo(() => {
		if (!graphicDesigners || graphicDesigners.length === 0) return graphicDesigners;

		const currentUserId = localStorage.getItem('userInfo');

		const sorted = [...graphicDesigners].sort((a, b) => {
			if (a.id === currentUserId) return -1;
			if (b.id === currentUserId) return 1;
			return 0;
		});

		return sorted;
	}, [graphicDesigners]);

	return (
		<React.Fragment>
			<div className="style-details-item">
				<DesignImageUpdate
					handleCropeImage={onCropeImage}
					handleDesignUpload={onDesignUpload}
					isDesignEdit={true}
					selectedImage={selectedImage}
				/>
				<div className="teckpack-info-item">
					<DesignEditInput
						label="Nitex Design No."
						type="text"
						name="designNum"
						value={selectedDesignInfo.designNum}
						onChangeHandler={onDesignInputChange}
						disabled={!isAdmin()}
						inputClassName={!isAdmin() ? 'disabled' : ''}
					/>
					<DesignEditInput
						label="Buyer Design No."
						type="text"
						name="buyerDesignNum"
						value={selectedDesignInfo.buyerDesignNum}
						onChangeHandler={onDesignInputChange}
						// disabled={}
					/>

					<DropdownWrapper
						label="Market*"
						isEditEnabled={isDesignEdit}
						readOnlyText={selectedDesignInfo?.selectedMarket?.name}
					>
						<CustomDropdown
							title="Select"
							items={marketList}
							onItemClick={(item) => {
								onSelectOption(item, 'selectedMarket');
							}}
							selectedItem={selectedDesignInfo?.selectedMarket?.name}
							isShowSearch={false}
							type="selectedMarket"
							// isDisabled={!isEditable()}
						/>
						{errors?.marketError && <span className="error">{errors?.marketError}</span>}
					</DropdownWrapper>

					<DropdownWrapper
						label="Category*"
						isEditEnabled={isDesignEdit}
						readOnlyText={selectedDesignInfo?.selectedCategory?.name}
						showTooltip
					>
						<CustomDropdown
							title="Select"
							items={categories}
							onItemClick={(item) => {
								onSelectOption(item, 'selectedCategory');
							}}
							selectedItem={selectedDesignInfo?.selectedCategory?.name}
							type="selectedCategory"
							toolTipLength={13}
							// isDisabled={!isEditable()}
						/>
						{errors?.categoryError && <span className="error">{errors?.categoryError}</span>}
					</DropdownWrapper>

					<DropdownWrapper
						label="Fabric Type"
						isEditEnabled={isDesignEdit}
						readOnlyText={capitalizeFirstLetter(selectedDesignInfo?.selectedFabricType?.name)}
					>
						<CustomDropdown
							title="Select"
							items={fabricType}
							onItemClick={(item) => {
								onSelectOption(item, 'selectedFabricType');
							}}
							isShowSearch={false}
							selectedItem={capitalizeFirstLetter(selectedDesignInfo?.selectedFabricType?.name)}
							type="selectedFabricType"
							// isDisabled={!isEditable()}
						/>
					</DropdownWrapper>

					{/* <DropdownWrapper
						label="Body Fabric"
						isEditEnabled={isDesignEdit}
						readOnlyText={selectedDesignInfo?.selectedBodyFabric?.name}
						showTooltip
					>
						<CustomDropdown
							title="Select"
							items={bodyFabric}
							onItemSearch={(value) => onGetBodyFabrics(value)}
							onItemClick={(item) => {
								onUpdateBodyFabric(item, 'selectedBodyFabric');
							}}
							selectedItem={selectedDesignInfo?.selectedBodyFabric?.name}
							type="selectedBodyFabric"
							toolTipLength={13}
							onAddNewButtonClick={(value) => {
								onParseInputName('MAIN_FABRIC', value);
							}}
							showAddNewButton={!isFashionDesigner()}
							// isDisabled={!isEditable()}
						/>
					</DropdownWrapper> */}
					<DropdownWrapper
						label="Brand"
						isEditEnabled={isDesignEdit}
						readOnlyText={selectedDesignInfo?.selectedBrand?.name}
					>
						<CustomDropdown
							title="Select"
							items={brands}
							onItemClick={(item) => {
								onSelectOption(item, 'selectedBrand');
							}}
							selectedItem={selectedDesignInfo?.selectedBrand?.name}
							type="selectedBrand"
							toolTipLength={15}
							isDisabled={!isAdmin()}
						/>
					</DropdownWrapper>
				</div>

				{/* Right Side */}

				<div className="teckpack-info-item">
					{/* <DropdownWrapper
						label="Sub-Brand"
						isEditEnabled={isDesignEdit}
						readOnlyText={selectedDesignInfo?.selectedBrand?.name}
					>
						<CustomDropdown
							title="Select"
							items={brands}
							onItemClick={(item) => {
								onSelectOption(item, 'selectedBrand');
							}}
							selectedItem={selectedDesignInfo?.selectedBrand?.name}
							type="selectedBrand"
							toolTipLength={15}
						/>
					</DropdownWrapper> */}

					<DropdownWrapper
						label="NITEX Design"
						isEditEnabled={isDesignEdit}
						readOnlyText={selectedDesignInfo?.selectedNitexDesign?.name}
					>
						<CustomDropdown
							title="Select"
							items={NITEX_DESIGN}
							onItemClick={(item) => {
								onSelectOption(item, 'selectedNitexDesign');
							}}
							selectedItem={selectedDesignInfo?.selectedNitexDesign?.value}
							type="selectedNitexDesign"
							isShowSearch={false}
							isDisabled={!isAdmin()}
						/>
					</DropdownWrapper>

					<DropdownWrapper
						label="Designed by"
						isEditEnabled={isDesignEdit && isOption()}
						readOnlyText={selectedDesignInfo?.selectedDesigner?.name}
					>
						<CustomDropdown
							title="Select"
							items={designers}
							onItemClick={(item) => {
								onSelectOption(item, 'selectedDesigner');
							}}
							selectedItem={selectedDesignInfo?.selectedDesigner?.name}
							type="selectedDesigner"
							toolTipLength={15}
							isDisabled={!isEditable()}
						/>
					</DropdownWrapper>

					<DropdownWrapper
						label="Graphic designer"
						isEditEnabled={isDesignEdit && isOption()}
						readOnlyText={selectedDesignInfo?.graphicDesigner?.name}
					>
						<CustomDropdown
							title="Select"
							items={sortedGraphicDesigners}
							onItemClick={(item) => {
								onSelectOption(item, 'graphicDesigner');
							}}
							selectedItem={selectedDesignInfo?.graphicDesigner?.name}
							type="graphicDesigner"
							toolTipLength={15}
							isDisabled={!isEditable()}
						/>
					</DropdownWrapper>

					<DropdownWrapper
						label="TP Completed By"
						isEditEnabled={isDesignEdit}
						readOnlyText={selectedDesignInfo?.selectedTpCompleatedBy?.name}
					>
						<CustomDropdown
							title="Select"
							items={tpCompleatedBy}
							onItemClick={(item) => {
								onSelectOption({ ...item, name: item?.nickName }, 'selectedTpCompleatedBy');
							}}
							selectedItem={selectedDesignInfo?.selectedTpCompleatedBy?.name}
							type="selectedTpCompleatedBy"
							toolTipLength={15}
							// isDisabled={!isEditable()}
						/>
					</DropdownWrapper>
					<DropdownWrapper
						label="Customised by"
						isEditEnabled={isDesignEdit}
						readOnlyText={selectedDesignInfo?.selectedCustomizeBy?.name}
					>
						<CustomDropdown
							title="Select"
							items={tpCompleatedBy}
							onItemClick={(item) => {
								onSelectOption({ ...item, name: item?.nickName }, 'selectedCustomizeBy');
							}}
							selectedItem={selectedDesignInfo?.selectedCustomizeBy?.name}
							type="selectedCustomizeBy"
							toolTipLength={15}
							// isDisabled={!isEditable()}
						/>
					</DropdownWrapper>
					<DesignEditInput
						label="Created by"
						type="text"
						name="buyerDesignNum"
						value={`${designDetails?.addedByName ? designDetails?.addedByName : ''} ${
							designDetails?.addedByName ? ', ' : ''
						} ${designDetails?.addedAt ? convertDateToLocal(designDetails?.addedAt, 'DD-MMM, YY') : ''}`}
						onChangeHandler={onDesignInputChange}
						disabled={true}
					/>
				</div>
				<div className="teckpack-info-item">
					<CollectionInfo
						collectionName={designDetails?.collectionName}
						season={designDetails?.season}
						collectionId={designDetails?.collectionId}
					/>
					{/* for 3d designer */}
					<div className="style-single mb-2">
						{isDesignEdit ? (
							<CustomDropdown
								title="3D Designer"
								items={threeDDesigner}
								onItemClick={(item) => {
									onSelectOption(item, 'selectedThreeDDesigner');
								}}
								selectedItem={selectedDesignInfo?.selectedThreeDDesigner?.name}
								type="selectedThreeDDesigner"
								toolTipLength={15}
							/>
						) : (
							<div className="click-box click mb-1">
								<p className="regular-14">
									{selectedDesignInfo?.selectedThreeDDesigner?.name
										? selectedDesignInfo?.selectedThreeDDesigner?.name
										: '3D Designer'}
								</p>
							</div>
						)}
					</div>
					{/* <FittingInfo designDetails={designDetails} /> */}
					<div className={`style-single mb-2`}>
						<div className="form-group mb-0 w-100">
							{isDesignEdit ? (
								<CustomDropdown
									title="Select look"
									items={looks}
									onItemClick={(item) => {
										onSelectOption(item, 'selectedLook');
									}}
									selectedItem={selectedDesignInfo?.selectedLook?.name}
									type="selectedLook"
									toolTipLength={15}
									// isDisabled={!isEditable()}
								/>
							) : (
								<div className="click-box click mb-1">
									<p className="regular-14">
										{selectedDesignInfo?.selectedLook?.name
											? selectedDesignInfo?.selectedLook?.name
											: 'Select look'}
									</p>
								</div>
							)}
						</div>
					</div>

					<DesignTag
						isEdit={true}
						dropdownTagList={tags}
						productId={productId}
						productTags={designDetails?.tagResponseList}
						updateTagList={onUpdateTagList}
						getAllTags={onGetAllTags}
						currentProductTagList={designDetails?.tagResponseList}
						remarks={remarks}
						setRemarks={setRemarks}
					/>
				</div>
			</div>
		</React.Fragment>
	);
};

export default DesignBasicInfoSection;
